import './styles/quasar.scss'
import '@quasar/extras/material-icons/material-icons.css'
import '@quasar/extras/fontawesome-v6/fontawesome-v6.css'
import Loading from 'quasar/src/plugins/loading/Loading.js';
// To be used on app.use(Quasar, { ... })
export default {
    plugins: [
      Loading
    ],
    config: {
      loading: {}
    }
}
